(function () {
  if (window.__belnayCurrencyMenu) return;
  window.__belnayCurrencyMenu = true;

  var shield = document.createElement('div');
  shield.className = 'currency-selector__shield';
  shield.hidden = true;
  shield.setAttribute('data-currency-shield', '');
  shield.setAttribute('aria-hidden', 'true');

  function syncHeaderState() {
    var headerOpen = !!document.querySelector('[data-currency-selector].currency-selector--header.is-open');
    document.body.classList.toggle('currency-menu-open', headerOpen);
  }

  function shieldHost(root) {
    return root.closest('.mobile-nav') || root.closest('.shopify-section') || document.body;
  }

  function showShield(root) {
    var host = shieldHost(root);
    if (shield.parentElement !== host) host.appendChild(shield);
    shield.hidden = false;
    shield.classList.add('is-active');
  }

  function hideShield() {
    shield.classList.remove('is-active');
    shield.hidden = true;
  }

  /* A miss lands on the shield or on whatever sits behind the list.
     Swallow it here, before a link such as Shop can run. */
  function openRootFromEvent(event) {
    var open = document.querySelector('[data-currency-selector].is-open');
    if (!open) return null;
    if (open.contains(event.target)) return null;
    return open;
  }

  document.addEventListener('pointerdown', function (event) {
    if (!openRootFromEvent(event)) return;
    event.stopPropagation();
  }, true);

  document.addEventListener('click', function (event) {
    var open = openRootFromEvent(event);
    if (!open) return;
    if (open.__currencyDragged) {
      open.__currencyDragged = false;
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (open.__belnayCurrencyClose) open.__belnayCurrencyClose(false);
  }, true);

  function bind(root) {
    if (root.dataset.currencyBound === '1') return;
    root.dataset.currencyBound = '1';

    var trigger = root.querySelector('[data-currency-toggle]');
    var panel = root.querySelector('[data-currency-panel]');
    var search = root.querySelector('[data-currency-filter]');
    var list = root.querySelector('[data-currency-list]');
    var bar = root.querySelector('[data-currency-bar]');
    var thumb = root.querySelector('[data-currency-thumb]');
    var empty = root.querySelector('[data-currency-empty]');
    var clear = root.querySelector('[data-currency-clear]');
    var dismiss = root.querySelector('[data-currency-dismiss]');
    var form = root.querySelector('form');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-currency-option]'));
    if (!trigger || !panel) return;

    function filter(term) {
      var query = (term || '').trim().toLowerCase();
      var matches = 0;
      options.forEach(function (option) {
        var name = option.dataset.name || '';
        var iso = option.dataset.iso || '';
        var currency = option.dataset.currency || '';
        var hit = query === '' || name.indexOf(query) !== -1 || iso.indexOf(query) === 0 || currency.indexOf(query) === 0;
        option.hidden = !hit;
        if (hit) matches += 1;
      });
      if (empty) empty.hidden = matches > 0;
      if (list) list.scrollTop = 0;
      if (clear) clear.hidden = query === '';
      syncThumb();
    }

    var hideTimer = 0;
    var phoneMenuQuery = window.matchMedia('(max-width: 899px)');

    function onDocumentClick(event) {
      if (!root.contains(event.target)) close(false);
    }

    function phoneMenu() {
      return phoneMenuQuery.matches && root.classList.contains('currency-selector--mobile');
    }

    function placePhonePanel() {
      if (!phoneMenu()) {
        panel.style.bottom = '';
        panel.style.maxHeight = '';
        return;
      }
      var rect = trigger.getBoundingClientRect();
      var gap = 8;
      panel.style.bottom = Math.max(8, Math.round(window.innerHeight - rect.top + gap)) + 'px';
      panel.style.maxHeight = Math.max(220, Math.round(rect.top - gap - 12)) + 'px';
    }

    function finishHide() {
      hideTimer = 0;
      if (root.classList.contains('is-open')) return;
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
      panel.style.bottom = '';
      panel.style.maxHeight = '';
    }

    function close(focusTrigger) {
      trigger.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-open');
      if (!document.querySelector('[data-currency-selector].is-open')) hideShield();
      document.removeEventListener('click', onDocumentClick);
      syncHeaderState();
      if (hideTimer) window.clearTimeout(hideTimer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finishHide();
      else hideTimer = window.setTimeout(finishHide, 260);
      if (focusTrigger) trigger.focus();
    }

    /* The footer copy arrives without its countries (see the snippet). */
    function fillOptions() {
      if (options.length || !list) return;
      document.querySelectorAll('[data-currency-option]').forEach(function (source) {
        var option = source.cloneNode(true);
        option.hidden = false;
        list.insertBefore(option, empty);
        options.push(option);
      });
    }

    function open() {
      if (hideTimer) window.clearTimeout(hideTimer);
      fillOptions();
      document.querySelectorAll('[data-currency-selector].is-open').forEach(function (other) {
        if (other !== root && other.__belnayCurrencyClose) other.__belnayCurrencyClose(false);
      });
      if (search && search.value) {
        search.value = '';
        filter('');
      }
      trigger.setAttribute('aria-expanded', 'true');
      placePhonePanel();
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      var active = root.querySelector('.currency-selector__option.is-active');
      if (active && list) {
        list.scrollTop = Math.max(0, active.offsetTop - list.clientHeight / 2);
      }
      syncThumb();
      panel.getBoundingClientRect();
      root.classList.add('is-open');
      showShield(root);
      document.addEventListener('click', onDocumentClick);
      syncHeaderState();
      document.dispatchEvent(new CustomEvent('belnay:currency-open'));
      if (search && !phoneMenu()) window.requestAnimationFrame(function () { search.focus(); });
    }

    function syncThumb() {
      if (!list || !bar || !thumb) return;
      var max = list.scrollHeight - list.clientHeight;
      if (max <= 1) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;
      var track = bar.clientHeight || list.clientHeight;
      var size = Math.max(28, track * (list.clientHeight / list.scrollHeight));
      var travel = Math.max(0, track - size);
      var y = (list.scrollTop / max) * travel;
      thumb.style.height = size + 'px';
      thumb.style.transform = 'translateY(' + y + 'px)';
    }

    if (list) list.addEventListener('scroll', syncThumb, { passive: true });

    if (bar && list && thumb) {
      var drag = null;
      bar.addEventListener('pointerdown', function (event) {
        if (event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        var bounds = bar.getBoundingClientRect();
        var size = thumb.getBoundingClientRect().height || 28;
        var travel = Math.max(1, bounds.height - size);
        var max = list.scrollHeight - list.clientHeight;
        var y = event.clientY - bounds.top - size / 2;
        list.scrollTop = Math.max(0, Math.min(max, (y / travel) * max));
        drag = { id: event.pointerId, offset: size / 2, moved: false, y: event.clientY };
        try { bar.setPointerCapture(event.pointerId); } catch (err) {}
      });
      bar.addEventListener('pointermove', function (event) {
        if (!drag || drag.id !== event.pointerId) return;
        if (Math.abs(event.clientY - drag.y) > 2) drag.moved = true;
        var bounds = bar.getBoundingClientRect();
        var size = thumb.getBoundingClientRect().height || 28;
        var travel = Math.max(1, bounds.height - size);
        var max = list.scrollHeight - list.clientHeight;
        var y = event.clientY - bounds.top - drag.offset;
        list.scrollTop = Math.max(0, Math.min(max, (y / travel) * max));
      });
      function endDrag(event) {
        if (!drag || event.pointerId !== drag.id) return;
        var moved = drag.moved;
        drag = null;
        if (!moved) return;
        var released = document.elementFromPoint(event.clientX, event.clientY);
        if (released && root.contains(released)) return;
        root.__currencyDragged = true;
      }
      bar.addEventListener('pointerup', endDrag);
      bar.addEventListener('pointercancel', endDrag);
    }

    if (panel && list) {
      panel.addEventListener('wheel', function (event) {
        var max = list.scrollHeight - list.clientHeight;
        if (max <= 1) return;
        var delta = event.deltaY;
        if (event.deltaMode === 1) delta *= 16;
        else if (event.deltaMode === 2) delta *= list.clientHeight;
        event.preventDefault();
        list.scrollTop = Math.max(0, Math.min(max, list.scrollTop + delta));
      }, { passive: false });
    }

    root.__belnayCurrencyClose = close;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (trigger.getAttribute('aria-disabled') === 'true') return;
      if (trigger.getAttribute('aria-expanded') === 'true') close(false);
      else open();
    });

    if (search) {
      search.addEventListener('input', function () { filter(search.value); });
      search.addEventListener('focus', function () {
        if (clear) clear.hidden = search.value === '';
      });
      search.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        var first = null;
        for (var i = 0; i < options.length; i += 1) {
          if (!options[i].hidden) {
            first = options[i];
            break;
          }
        }
        if (first) first.click();
      });
    }

    if (clear) {
      clear.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!search) return;
        search.value = '';
        search.dispatchEvent(new Event('input', { bubbles: true }));
        search.focus();
      });
    }

    if (dismiss) {
      dismiss.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        close(false);
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        if (!submitter || submitter.name !== 'country_code') return;
        event.preventDefault();
        var back = window.location.pathname + window.location.search;
        var returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = back;
        var y = window.scrollY || 0;
        var top = document.body.style.top;
        if (document.body.style.position === 'fixed' && top) {
          var pinned = parseInt(top, 10);
          if (pinned < 0) y = -pinned;
        }
        try {
          window.sessionStorage.setItem('belnay-scroll-y:' + back, String(y));
          window.sessionStorage.setItem('belnay-scroll-force', back);
        } catch (err) {}
        window.addEventListener('pagehide', function () {
          try {
            window.sessionStorage.setItem('belnay-scroll-y:' + back, String(y));
            window.sessionStorage.setItem('belnay-scroll-force', back);
          } catch (err2) {}
        }, { once: true });
        var data = new FormData(form);
        data.set('country_code', submitter.value);
        data.set('return_to', back);
        var sent = false;
        function go() {
          if (sent) return;
          sent = true;
          window.location.replace(back);
        }
        function nativeSubmit() {
          if (sent) return;
          var hidden = form.querySelector('input[type="hidden"][name="country_code"]');
          if (!hidden) {
            hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'country_code';
            form.appendChild(hidden);
          }
          hidden.value = submitter.value;
          form.submit();
        }
        if (!window.fetch) {
          nativeSubmit();
          return;
        }
        window.fetch(form.action, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          redirect: 'follow'
        }).then(function (res) {
          if (!res || (res.type !== 'opaqueredirect' && !res.ok)) throw new Error('localization');
          go();
        }).catch(function () {
          nativeSubmit();
        });
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        close(true);
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      var visible = options.filter(function (option) { return !option.hidden; });
      if (!visible.length) return;
      event.preventDefault();
      var current = visible.indexOf(document.activeElement);
      var step = event.key === 'ArrowDown' ? 1 : -1;
      var next = current === -1 ? 0 : (current + step + visible.length) % visible.length;
      visible[next].focus();
    });
  }

  function boot() {
    document.querySelectorAll('[data-currency-selector]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('belnay:shop-mega-open', function () {
    document.querySelectorAll('[data-currency-selector].is-open').forEach(function (root) {
      if (root.__belnayCurrencyClose) root.__belnayCurrencyClose(false);
    });
  });
})();
